module.exports = __webpack_public_path__ + "img/672820b.png";